import { styled } from '@linaria/react';
import { colors, fonts, semantic, size, space } from '../../theme/tokens';

export const MonthWrapper = styled.div`
  width: 100%;
`;

export const MonthHeader = styled.div`
  display: grid;
  grid-template-columns: ${space['space-800']} 1fr ${space['space-800']};
  align-items: center;
  padding: ${space['space-200']} 0 ${space['space-300']};
  font-family: ${fonts.body};
  font-size: ${fonts.size.md};
  font-weight: ${fonts.weight.semiBold};
  color: ${semantic.text.primary};

  &[data-no-nav] {
    display: block;
    text-align: left;
    padding-left: ${space['space-300']};
  }
`;

export const MonthLabel = styled.span`
  text-align: center;
`;

export const NavSlot = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const NavButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${space['space-800']};
  height: ${space['space-800']};
  border: none;
  background: transparent;
  border-radius: ${size.radius['radius-full']};
  color: ${semantic.text.primary};
  cursor: pointer;
  padding: 0;
  transition: background-color 0.15s ease;

  &:disabled {
    color: ${semantic.text.tertiary};
    cursor: not-allowed;
  }

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }

  &:hover:not(:disabled) {
    background: ${semantic.bg.surfaceSubtle};
  }
`;

export const WeekdayRow = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: ${space['space-050']};
  margin-bottom: ${space['space-100']};

  @media screen and (max-width: 600px) {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }
`;

export const WeekdayLabel = styled.span`
  text-align: center;
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  font-weight: ${fonts.weight.semiBold};
  color: ${semantic.text.secondary};
  text-transform: uppercase;
  padding: ${space['space-100']} 0;
`;

export const DaysGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 0;

  @media screen and (max-width: 600px) {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }
`;

export const DayWrapper = styled.div`
  &:hover {
    z-index: 1;
  }
`;
